export { default } from './CtaTopRight'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/CtaTopRight/index.js